export const UploadIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1269_16872)">
        <rect
          x="0.139648"
          y="0.09375"
          width="40"
          height="40"
          rx="20"
          fill="#D4002A"
        />
        <g clipPath="url(#clip1_1269_16872)">
          <path
            d="M19.8296 20.4609V11.7109"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.7046 20.4609V24.8359C26.7046 25.0017 26.6387 25.1607 26.5215 25.2779C26.4043 25.3951 26.2454 25.4609 26.0796 25.4609H13.5796C13.4138 25.4609 13.2549 25.3951 13.1376 25.2779C13.0204 25.1607 12.9546 25.0017 12.9546 24.8359V20.4609"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.7046 14.8359L19.8296 11.7109L22.9546 14.8359"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1269_16872">
          <rect
            x="0.139648"
            y="0.09375"
            width="40"
            height="40"
            rx="20"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_1269_16872">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(9.82959 11.0859)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
